/*
 * @Author: Teemo Ding
 * @Date: 2021-11-10 09:44:58
 * @LastEditTime: 2022-01-20 11:15:50
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/index.ts
 */
import PickAndPack from './PickAndPack';
import ClickAndCollect from './ClickAndCollect';

export { PickAndPack, ClickAndCollect };

import ReadyToPack from './ReadyToPack';
import ReadyToShip from './ReadyToShip';
import ReadyToCollect from './ReadyToCollect';
import Notified from './Notified';
import Delivery from './Delivery';
import Collected from './Collected';
import VirtualProduct from './VirtualProduct';

export {
  ReadyToPack,
  ReadyToShip,
  ReadyToCollect,
  Notified,
  Delivery,
  Collected,
  VirtualProduct,
};
